import { Rooms } from '@hfs/website/api/resources/search/rooms'
import { room } from '@hfs/website/mocks/room'

export const rooms: Rooms = [room, { ...room, uuid: '5edf78a3-7989-495f-b08f-2cf32ee55436' }]
